module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d3/sec02_sp_a9732c94552e4c131dce12e6fe709e88.jpg";